export default __webpack_public_path__ + "static/media/ux-ui.f2f89c27.svg";